import plugin_vue3_A0OWXRrUgq from "E:/workspace/roncoo/roncoo-web/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "E:/workspace/roncoo/roncoo-web/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "E:/workspace/roncoo/roncoo-web/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "E:/workspace/roncoo/roncoo-web/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "E:/workspace/roncoo/roncoo-web/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "E:/workspace/roncoo/roncoo-web/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import ssr_plugin_B4ptqVdIfe from "E:/workspace/roncoo/roncoo-web/node_modules/@vueuse/nuxt/ssr-plugin.mjs";
import auth_listener_client_GmAJa92k7S from "E:/workspace/roncoo/roncoo-web/plugins/auth-listener.client.js";
import browser_compat_client_M1RwZKSxNV from "E:/workspace/roncoo/roncoo-web/plugins/browser-compat.client.js";
import element_plus_elM4AXquKi from "E:/workspace/roncoo/roncoo-web/plugins/element-plus.js";
import global_dY5SAi3BsR from "E:/workspace/roncoo/roncoo-web/plugins/global.js";
import katex_client_ALfa43jrwY from "E:/workspace/roncoo/roncoo-web/plugins/katex.client.js";
import radio_fix_client_X7hIokAPBh from "E:/workspace/roncoo/roncoo-web/plugins/radio-fix.client.js";
import scroll_top_client_dHlgrwPJqx from "E:/workspace/roncoo/roncoo-web/plugins/scroll-top.client.js";
export default [
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  ssr_plugin_B4ptqVdIfe,
  auth_listener_client_GmAJa92k7S,
  browser_compat_client_M1RwZKSxNV,
  element_plus_elM4AXquKi,
  global_dY5SAi3BsR,
  katex_client_ALfa43jrwY,
  radio_fix_client_X7hIokAPBh,
  scroll_top_client_dHlgrwPJqx
]